import styled from 'styled-components'

import Pill from 'components/Pill/Pill'

export const StyledPill = styled(Pill)`
  margin-left: 4px;
`
